module.exports = __webpack_public_path__ + "img/LDSJ_STILL27.2823d9bc.jpg";